// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// SaveProgramDetailsHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import ProgramDTO from '../models/ProgramDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    program: ProgramDTO | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            program: null,
        },
        initValues);
    },
    program: 'program',
}

interface Result extends ResultDTO {
    program: ProgramDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            program: null,
        },
        initValues);
    },
    program: 'program',
}

export { Request, Result };